import { Box, Button, Stack, Menu, MenuItem } from "@mui/material";
import * as XLSX from "xlsx";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { maintenanceAnalysisColumnData } from "../../common/constants/gridRowColumn";
import {
  useCompany,
  useDealer,
  useMaintainance,
  useMovableColumn,
  useNewVehicle,
  usePagination,
  useReplacement,
  useSortableColumn,
  useUser,
} from "../../common/hooks";
import { SearchBar } from "../../components/SearchBar";
import { layoutStyle } from "../layout-ui/style";
import { DeleteDialog } from "../../components/DeleteDialog";
import { TruckLoader } from "./truckLoader";
import { useDebounce } from "../../components/useDebounce";
import {
  actionColumnFunction,
  checkFieldColumn,
  checkbox,
  getDefaultColDef,
  sidebarMenu,
} from "../../common/constants/commonFunction";
import { getCompanyId } from "../../common/constants/commonFunction";
import { TAB_CONTENT, TAB_VALUE } from "../../common/constants/popupMessage";
import { localStorageItemNames } from "../../common/constants";
import { PageNameConstant } from "../../common/constants/PageNameConstant";
import { PopupBlock } from "../../components/PopupBlock";
import { onSortChanged } from "../../common/utils/sortingColumn";
import { columnSortingMessage } from "../../common/utils/columnSortingMessage";
import { SortingTextPopup } from "../../components/SortingTextPopup";

export const MaintenanceAnalysis = () => {
  const classes = layoutStyle();
  const [columnFinal, setColumnFinal] = useState([]);
  const [rowDataFinal, setRowDataFinal] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  // const [deleteValue, setDeleteValue] = useState();
  // const { state } = useLocation();
  const navigation = useNavigate();
  const {
    getMaintananceApi,
    maintanance,
    // deleteMaintananceByIdApi,
    loading,
    setMaintanance,
  } = useMaintainance();
  const {
    setSelectedNav,
    columnChange,
    setColumnChange,
    popupBlock,
    setPopupBlock,
    setSidebarColumnPopup,
  } = useUser();
  const { companyNameHeader, dealerNameHeader } = useCompany();
  const userType = localStorage.getItem("type");
  const defaultColDef = useMemo(() => getDefaultColDef(), []);
  const { setNewFleetNo } = useDealer();
  const { setToastClose, setNewVehicle } = useNewVehicle();
  const { setReplacementList } = useReplacement();
  const gridRef = useRef(null);
  const [movableColumnData, setMovableColumnData] = useState([]);
  const {
    movableColumn,
    getMovableColumnApi,
    createMovableColumn,
    updateViewMovableColumn,
    sortedColumn,
    setSortedColumn,
  } = useMovableColumn();
  const [nextButton, setNextButton] = useState("");
  const [prevButton, setPrevButton] = useState("");
  const [openSortingPopup, setOpenSortingPopup] = useState(false);
  const [anchorElExport, setAnchorElExport] = useState(null);

  const handleClickExport = (event) => {
    setAnchorElExport(event.currentTarget);
  };

  const handleCloseExport = () => {
    setAnchorElExport(null);
  };

  const handleExportFile = (format) => {
    if (!gridRef?.current?.api) return;
    const rows = [];
    gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
      rows.push(node.data);
    });

    const exportData = rows.map((row) => {
      const mappedRow = {};
      mappedRow.VIN = row.vin || "";
      mappedRow.Year = row.year || "";
      mappedRow.Make = row.make || "";
      mappedRow.Model = row.model || "";
      columnFinal?.forEach((col) => {
        if (col.field && col.field !== "action" && col.headerName) {
          const value = row[col.field];
          mappedRow[col.headerName] = value;
        }
      });
      return mappedRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(
      exportData?.length ? exportData : rows,
    );
    const workbook = XLSX.utils.book_new();
    const sheetName = "Maintenance Analysis";
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    const reportName = [companyNameHeader?.companyName, sheetName]
      .filter(Boolean)
      .join(" - ")
      .replace(/[\\/:*?"<>|]/g, "-");
    const fileName =
      format === "csv" ? `${reportName}.csv` : `${reportName}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    handleCloseExport();
  };

  const {
    getSortableColumnApi,
    sortableColumnData,
    createSortableColumn,
    updateViewSortableColumn,
  } = useSortableColumn();
  const {
    setPagination,
    setFleetPagination,
    setMaintainancePagination,
    setFuelPagination,
    setFundingPagination,
  } = usePagination();

  useEffect(() => {
    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.maintenanceAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    setNewFleetNo(null);
    setToastClose(false);
    setNewVehicle([]);
    setReplacementList([]);
    setSidebarColumnPopup("");
    setPagination(0);
    setFleetPagination(0);
    setMaintainancePagination(0);
    setFuelPagination(0);
    setFundingPagination(0);
  }, []);
  const handleAddButton = () => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FLEET_LIST,
        selectedContent: TAB_CONTENT.FLEET_LIST,
      },
    });
  };
  const onCellClicked = (event) => {
    let checkField = checkFieldColumn(event);
    if (checkField) {
      handleEditButton(event?.data);
    }
  };
  const handleEditButton = (params) => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.MAINTENANCE_ANALYSIS,
        selectedContent: TAB_CONTENT.MAINTENANCE_ANALYSIS,
        data: params,
      },
    });
  };

  // const handleDeleteButton = async (values) => {
  //   setDeleteOpen(true);
  //   setDeleteValue(values);
  // };

  // const handleDelete = async () => {
  //   const companyId = getCompanyId(userType, companyNameHeader);
  //   let payload = {
  //     id: deleteValue,
  //     companyId: companyId,
  //   };
  //   await deleteMaintananceByIdApi(payload);
  //   setDeleteOpen(false);
  // };

  // const [anchorElSearch, setAnchorElSearch] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const onSearch = (e) => {
    debouncedSearch(e?.target?.value);
    handleClickSearch(e);
  };
  const handleClickSearch = (event) => {
    // setAnchorElSearch(event.currentTarget);
  };

  const onSearchFunc = (e) => {
    setSearchValue(e[0]);
  };
  const searchData = rowDataFinal?.filter((maintanace) =>
    maintanace?.fleetNo?.toLowerCase().includes(searchValue?.toLowerCase()),
  );
  const debouncedSearch = useDebounce(onSearchFunc, 500);

  useEffect(() => {
    if (searchValue) {
      setRowDataFinal([...searchData]);
    } else if (maintanance?.length > 0) {
      setRowDataFinal([...maintanance]);
    }
  }, [searchValue, maintanance]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sortedColumn?.length > 0) {
      const dataFinal = [];

      // Step 1: Add matching fleet numbers in the correct sequence
      sortedColumn.forEach((fleetNo) => {
        const match = maintanance.find((item) => item.fleetNo === fleetNo);
        if (match) dataFinal.push(match);
      });

      // Step 2: Append remaining fleet numbers (not in sortedColumn)
      const remainingData = maintanance.filter(
        (item) => !sortedColumn.includes(item.fleetNo),
      );

      dataFinal.push(...remainingData);
      setRowDataFinal([...dataFinal]);
    } else if (maintanance?.length > 0) {
      setRowDataFinal(maintanance);
    } else {
      setRowDataFinal([]);
    }
  }, [maintanance]);
  useEffect(() => {
    if (sortableColumnData?.length > 0) {
      let sortingColumnData = sortableColumnData[0]?.fleetDetails;
      let sortingValue = JSON.parse(sortingColumnData);
      setSortedColumn([...sortingValue]);
    }
  }, [sortableColumnData]);
  useEffect(() => {
    setColumnChange(false);

    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.maintenanceAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    if (companyNameHeader) {
      const companyId = getCompanyId(userType, companyNameHeader);
      getMaintananceApi({
        companyId: companyId,
        dealerId: dealerNameHeader?.id,
      });
    } else {
      setMaintanance([]);
    }
  }, [companyNameHeader]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (movableColumnData) {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        deleteButton: false,
      });
      setColumnFinal([...movableColumnData]);
    }
  }, [movableColumnData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sortableColumnData?.length > 0 && movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      if (sortableColumnData?.length > 0) {
        columnParse?.map((item) => {
          if (
            item.field === sortableColumnData[0].sortedColumn &&
            sortableColumnData[0].pageName ===
              PageNameConstant.replacementSchedule
          ) {
            item["sort"] = sortableColumnData[0].direction;
          } else {
            item["sort"] = null;
          }
        });
      }
      setMovableColumnData(columnParse);
    } else if (movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      setMovableColumnData(columnParse);
    } else {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        deleteButton: false,
      });
      setMovableColumnData([
        checkbox,
        ...maintenanceAnalysisColumnData,
        actionColumn,
      ]);
    }
  }, [maintenanceAnalysisColumnData, movableColumn]);
  const handleNext = (event) => {
    if (columnChange) {
      setPopupBlock(true);
      setNextButton("/fuel-analysis");
    } else {
      setSelectedNav(sidebarMenu.fuel);
      navigation("/fuel-analysis");
    }
  };
  const handleBack = () => {
    if (columnChange) {
      setPopupBlock(true);
      setPrevButton("/replacement-schedule");
    } else {
      setSelectedNav(sidebarMenu.replacement);
      navigation("/replacement-schedule");
    }
  };
  const handleMovableColumn = async () => {
    const cols = gridRef.current?.api?.getAllGridColumns();
    const colNamesIndex = cols?.map((items, index) => items?.colDef);
    setMovableColumnData(colNamesIndex);
    if (movableColumn?.length > 0) {
      await updateViewMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.maintenanceAnalysis,
        ColumnName: JSON.stringify(colNamesIndex),
        id: movableColumn[0]?.id,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    } else {
      await createMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.maintenanceAnalysis,
        ColumnName: JSON.stringify(colNamesIndex),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    }
    setColumnChange(false);
  };
  const handleColumnChange = (event) => {
    if (event?.column) {
      const cols = gridRef.current?.api?.getAllGridColumns();
      const colNamesIndex = cols?.map((items, index) => items?.colDef);
      setMovableColumnData(colNamesIndex);
      setColumnChange(true);
    }
  };
  const onSortedColumnChange = async () => {
    await onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      columnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      PageNameConstant.fleetList,
    );
  };
  const onSortedColumnChangeAlready = () => {
    setOpenSortingPopup(true);
  };
  return (
    <Box className={classes.mainContent}>
      <Box className={classes.gridContantFleetList}>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Box className={classes.headerNameText}>Maintenance Analysis</Box>
          <Box className={classes.sortingFieldText}>
            {sortableColumnData &&
            sortableColumnData?.length > 0 &&
            sortableColumnData[0]?.direction
              ? columnSortingMessage(
                  sortableColumnData,
                  PageNameConstant.maintenanceAnalysis,
                )
              : ""}
          </Box>
        </Stack>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Box></Box>
          <Box className={classes.addEditGrid}>
            {sortableColumnData?.length === 0 ? (
              <Button
                variant="outlined"
                className={classes.fleetListNewButton}
                onClick={onSortedColumnChange}
              >
                <span style={{ fontSize: 12 }}>Save Sort</span>
              </Button>
            ) : (
              <Button
                variant="outlined"
                className={classes.fleetListNewButton}
                onClick={onSortedColumnChangeAlready}
              >
                <span style={{ fontSize: 12 }}>Save Sort</span>
              </Button>
            )}
            <Button
              variant="outlined"
              className={classes.fleetListNewButton}
              onClick={handleMovableColumn}
            >
              <span style={{ fontSize: 12 }}>Save Columns</span>
            </Button>
            <Button
              variant="outlined"
              className={classes.fleetListNewButton}
              onClick={handleClickExport}
            >
              <span style={{ fontSize: 12 }}>Export</span>
            </Button>
            <Menu
              anchorEl={anchorElExport}
              open={Boolean(anchorElExport)}
              onClose={handleCloseExport}
            >
              <MenuItem onClick={() => handleExportFile("xlsx")}>
                Export XLSX
              </MenuItem>
              <MenuItem onClick={() => handleExportFile("csv")}>
                Export CSV
              </MenuItem>
            </Menu>
            <Button
              variant="outlined"
              className={classes.fleetListNewButton}
              onClick={handleBack}
            >
              <span style={{ fontSize: 12 }}>Back</span>
            </Button>
            <Button
              variant="outlined"
              className={classes.fleetListNewButton}
              onClick={handleNext}
            >
              <span style={{ fontSize: 12 }}>Next</span>
            </Button>
            <Button
              variant="outlined"
              className={classes.fleetListNewButton}
              onClick={handleAddButton}
            >
              NEW
            </Button>
            <SearchBar onSearch={onSearch} />
          </Box>
        </Stack>
        {loading ? (
          <TruckLoader />
        ) : (
          <AgGridReact
            ref={gridRef}
            className="ag-theme-quartz"
            rowSelection="multiple"
            onSelectionChanged={(event) => {
              const selectedNodes = event.api.getSelectedNodes();
              const selectedRows = selectedNodes.map((node) => node.data);
              setSelectedRows(selectedRows);
            }}
            suppressRowClickSelection
            pagination={true}
            rowData={rowDataFinal}
            defaultColDef={defaultColDef}
            checkboxSelection
            columnDefs={columnFinal}
            onCellClicked={onCellClicked}
            onColumnMoved={handleColumnChange}
          />
        )}
      </Box>
      {deleteOpen && (
        <DeleteDialog
          open={deleteOpen}
          setOpen={() => setDeleteOpen(false)}
          // deleteApi={() => handleDelete()}
        />
      )}
      {popupBlock && (
        <PopupBlock
          open={popupBlock}
          setOpen={() => setPopupBlock(false)}
          navigationRouteNext={nextButton}
          navigationRoutePrev={prevButton}
          selectedNavStyle={
            nextButton ? sidebarMenu.fuel : sidebarMenu.replacement
          }
          columnChangeData={movableColumnData}
          pageName={PageNameConstant.maintenanceAnalysis}
        />
      )}
      {openSortingPopup && (
        <SortingTextPopup
          open={openSortingPopup}
          setOpen={setOpenSortingPopup}
          gridRef={gridRef}
          setSortedColumn={setSortedColumn}
          setColumnFinal={setColumnFinal}
          columnFinal={columnFinal}
          sortableColumnData={sortableColumnData}
          createSortableColumn={createSortableColumn}
          updateViewSortableColumn={updateViewSortableColumn}
          pageName={PageNameConstant.maintenanceAnalysis}
        />
      )}
    </Box>
  );
};
